import { BrowserStorage } from 'utils/browserStorage';

const MAX_RECENT_LANGUAGES = 5;

export function getRecentLanguages(): string[] {
  try {
    const stored = BrowserStorage.get(
      BrowserStorage.keys.Translation.RecentLanguages,
    );
    if (!stored) return [];
    return JSON.parse(stored);
  } catch {
    return [];
  }
}

export function addRecentLanguage(language: string): void {
  const recent = getRecentLanguages();
  const filtered = recent.filter((l) => l !== language);
  const updated = [language, ...filtered].slice(0, MAX_RECENT_LANGUAGES);
  BrowserStorage.set(
    BrowserStorage.keys.Translation.RecentLanguages,
    JSON.stringify(updated),
  );
}

export function clearRecentLanguages(): void {
  BrowserStorage.remove(BrowserStorage.keys.Translation.RecentLanguages);
}
